import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import { StateType } from 'typesafe-actions';
import { ArticleListReducer } from '../business/Article/ArticleReducer';
import { StaticReducer } from './Static/StaticReducer';
import { authReducer } from './Auth/AuthReducer';
import { ProfileReducer } from './Profile/ProfileReducer';

export const rootReducer = combineReducers({
	auth: authReducer,
	profile: ProfileReducer,
	article: ArticleListReducer,
	static: StaticReducer
});

export const store = configureStore({
	devTools: true,
	reducer: rootReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: false
		})
});

export type RootState = StateType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
